import { onBeforeUnmount, onMounted } from 'vue'

export const STRIPE_LOAD_TIMEOUT_MS = 12000

export const STRIPE_LOAD_WARNING = 'The secure payment form is having trouble loading. Please refresh the page or check your internet connection before trying again.'

export const stripeLoadWarningMessage = (details = null) => {
  const message = typeof details === 'string'
    ? details
    : details?.message ?? details?.error?.message ?? ''

  return message
    ? `${STRIPE_LOAD_WARNING} ${message}`
    : STRIPE_LOAD_WARNING
}

export const useStripeLoadWarning = ({
  stripeLoaded,
  emit,
  setError = () => {},
} = {}) => {
  let loadTimer = null

  const clearStripeLoadWarning = () => {
    if (!loadTimer || typeof window === 'undefined') {
      loadTimer = null
      return
    }

    window.clearTimeout(loadTimer)
    loadTimer = null
  }

  const showStripeLoadWarning = (details = null) => {
    const message = stripeLoadWarningMessage(details)

    setError(message)
    emit?.('errors', [message])

    return message
  }

  const startStripeLoadTimer = () => {
    clearStripeLoadWarning()

    if (typeof window === 'undefined') {
      return
    }

    loadTimer = window.setTimeout(() => {
      if (!stripeLoaded?.value) {
        showStripeLoadWarning()
      }
    }, STRIPE_LOAD_TIMEOUT_MS)
  }

  onMounted(startStripeLoadTimer)
  onBeforeUnmount(clearStripeLoadWarning)

  return {
    clearStripeLoadWarning,
    showStripeLoadWarning,
    startStripeLoadTimer,
  }
}
